import React from "react";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Color } from "../../../../../components/Form/Button";
import Modal, { ModalType } from "../../../../../components/Generic/Modal";
import { NotificationToast } from "../../../../../components/Generic/Toast/NotificationToast";
import useStyles from "./styles";

interface Props {
  open?: boolean;
  onClose?: () => void;
  onSave?: () => void;
}

const UnlinkInventoryModal = (props: Props) => {
  const { open = false, onClose, onSave } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      open={open}
      className={classes.modal}
      handleClose={() => onClose && onClose()}
      title={translate("unlinkInventory")}
      showActionButtons
      type={ModalType.WARNING}
      actionButtonProps={{
        onCancel: onClose,
        onSave: () => {
          if (onSave) {
            onSave();
            NotificationToast.success(`${translate("inventoryUnlinkedSuccessfully")}!`);
          }
        },
        customColorSave: Color.WARNING,
        customColorCancel: Color.DARK,
        textCancel: translate("cancel"),
        textSave: translate("yesUnlink"),
      }}
    >
      <Stack width="100%" direction="column" spacing={1}>
        <span className={classes.textUnlinkModal}>
          {translate(
            "whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements"
          )}
        </span>
        <span className={classes.textUnlinkModal}>
          {translate("doYouWantToUnlinkTheInventory")}?
        </span>
      </Stack>
    </Modal>
  );
};

export default UnlinkInventoryModal;
